module.exports = __webpack_public_path__ + "f58bb15f57230cdba0f28a158e2b9fe7.jpg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/url-loader??ref--8-1!./node_modules/image-webpack-loader??ref--8-2!./node_modules/srcset-loader/lib/resize-loader.js?size=1800!./src/components/cover/teaser.jpg?size=1800w
// module id = 35
// module chunks = 1